import { createRoutine } from "../utils/routine.utils";
export var getFlags = createRoutine("FEATURE_FLAGS_GET");
